import React, { useCallback, useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import { Modal } from "react-bootstrap";
import swal from "sweetalert";

const InterpretationCategory = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [postModal, setPostModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [addFormData, setAddFormData] = useState({ Description: "" });

  const fetchData = useCallback(async (signal) => {
    setLoading(true);
    setError(null);
    try {
      const response = await AddUpdate(
        "AstrologyInterpretationRules/GetData_AstrologyCategory",
        {}
      );
      if (signal?.aborted) return;
      const parsed = JSON.parse(response?.data?.data || "{}");
      const rows = parsed?.Table || [];
      setData(rows);
    } catch (err) {
      if (signal?.aborted) return;
      console.error("Error fetching interpretation categories:", err);
      setError("Failed to load categories");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const controller = { aborted: false };
    fetchData(controller);
    return () => {
      controller.aborted = true;
    };
  }, [fetchData]);

  const columns = useMemo(
    () => [
      { name: "Category Id", selector: (row) => row.CategoryId, sortable: true },
      { name: "Category", selector: (row) => row.Category, sortable: true },
    ],
    []
  );

  const resetForm = useCallback(() => {
    setAddFormData({ Description: "" });
  }, []);

  const handleAddFormSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      if (!addFormData.Description?.trim()) {
        swal("Validation", "Category is required", "warning");
        return;
      }
      setSaving(true);
      try {
        const payload = { Category: addFormData.Description.trim(), CreatedByUserId: 1 };
        const response = await AddUpdate(
          "AstrologyInterpretationRules/Insert_AstrologyCategory",
          payload
        );
        if (response) {
          swal("Success", "Category added", "success");
          setPostModal(false);
          resetForm();
          fetchData();
        }
      } catch (err) {
        console.error("Error adding category:", err);
        swal("Error", "Could not add category", "error");
      } finally {
        setSaving(false);
      }
    },
    [addFormData, fetchData, resetForm]
  );

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <h2 className="text-warning fw-bold">Interpretation Categories</h2>
        <button className="btn btn-primary" onClick={() => setPostModal(true)}>
          Add Category
        </button>
      </div>

      <div className="col-12 mt-2">
        <DataTable
          dense
          data={data}
          columns={columns}
          selectableRowsHighlight
          highlightOnHover
          pagination
          fixedHeader
          customStyles={customStyles}
          persistTableHead
          noDataComponent={loading ? "Loading..." : "There are no data to display"}
        />
        {error && <div className="text-danger mt-2">{error}</div>}
      </div>

      <Modal show={postModal} onHide={() => setPostModal(false)} backdrop="static">
        <form onSubmit={handleAddFormSubmit}>
          <div className="modal-header">
            <h4 className="modal-title fs-20">Add Category</h4>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                setPostModal(false);
                resetForm();
              }}
            />
          </div>
          <div className="modal-body p-3">
            <div className="form-group">
              <label htmlFor="category-input" className="form-label">
                Category <span className="text-danger">*</span>
              </label>
              <input
                id="category-input"
                type="text"
                className="form-control"
                autoComplete="off"
                name="Description"
                required
                aria-required
                value={addFormData.Description}
                onChange={(e) => setAddFormData({ ...addFormData, Description: e.target.value })}
                placeholder="Enter category"
                disabled={saving}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? "Saving..." : "Save"}
            </button>
            <button
              type="button"
              onClick={() => {
                setPostModal(false);
                resetForm();
              }}
              className="btn btn-danger"
            >
              Close
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default InterpretationCategory;
